export enum ActivityKind {
  EMAIL = 'email',
  MEETING = 'meeting',
  PHONE = 'phone',
  VACATION = 'vacation',
  SIGNING_DOCUMENTS = 'signing_documents',
  OTHER = 'other',
}
